export default __webpack_public_path__ + "static/media/close.2da6f3d4.svg";